module.exports = __webpack_public_path__ + "assets/img/d79c9f95a123c3c27e330ab25d7b52c9.svg";